module.exports = __webpack_public_path__ + "img/rocket.48c927d2.png";